module.exports = __webpack_public_path__ + "static/assets/8a2a7dc2c57568fbd998b28ddb47bdc1.svg";